import { Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { changeModalAereo, clearError } from "../../../features/manifestoSlice";
import { MakeMessageError } from "../../../components/Components";


export default function ModalFormAereo() {
    const formManifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const dispatch = useDispatch();

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        dispatch(changeModalAereo({ [name]: value }));
        dispatch(clearError('modal_aereo_' + name))
    }

    return (<div className="px-2">
        <Row className="mb-3 g-2">
            <Col md>
                <Form.Group >
                    <Form.Label>Marca nacionalidade Aeronave</Form.Label>
                    <Form.Control type="text" name="nac" onChange={handleChange}
                        maxLength={4} value={formManifesto.modal_aereo.nac}
                        className={`${errors.modal_aereo_nac?.length > 0 ? "is-invalid" : ""}`}
                    />
                    <MakeMessageError errors={errors} field="modal_aereo_nac" />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group >
                    <Form.Label>Marca de Matricula da Aeronave</Form.Label>
                    <Form.Control type="text" name="matr" onChange={handleChange}
                        maxLength={6} value={formManifesto.modal_aereo.matr}
                        className={`${errors.modal_aereo_matr?.length > 0 ? "is-invalid" : ""}`}
                    />
                    <MakeMessageError errors={errors} field="modal_aereo_matr" />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group >
                    <Form.Label>Número do Voo</Form.Label>
                    <Form.Control type="text" name="nvoo" onChange={handleChange}
                        maxLength={9} value={formManifesto.modal_aereo.nvoo}
                        className={`${errors.modal_aereo_nvoo?.length > 0 ? "is-invalid" : ""}`}
                    />
                    <MakeMessageError errors={errors} field="modal_aereo_nvoo" />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group >
                    <Form.Label>Aeródromo de Embarque</Form.Label>
                    <Form.Control type="text" name="caeremb" onChange={handleChange}
                        maxLength={4} value={formManifesto.modal_aereo.caeremb}
                        className={`${errors.modal_aereo_caeremb?.length > 0 ? "is-invalid" : ""}`}
                    />
                    <MakeMessageError errors={errors} field="modal_aereo_caeremb" />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group >
                    <Form.Label>Aeródromo de destino</Form.Label>
                    <Form.Control type="text" name="caerdes" onChange={handleChange}
                        maxLength={4} value={formManifesto.modal_aereo.caerdes}
                        className={`${errors.modal_aereo_caerdes?.length > 0 ? "is-invalid" : ""}`}
                    />
                    <MakeMessageError errors={errors} field="modal_aereo_caerdes" />
                </Form.Group>
            </Col>
            <Col md={'auto'}>
                <Form.Group >
                    <Form.Label>Data do Voo</Form.Label>
                    <Form.Control type="date" name="dvoo" onChange={handleChange}
                        maxLength={4} value={formManifesto.modal_aereo.dvoo}
                        className={`${errors.modal_aereo_dvoo?.length > 0 ? "is-invalid" : ""}`}
                    />
                    <MakeMessageError errors={errors} field="modal_aereo_dvoo" />
                </Form.Group>
            </Col>

        </Row>

    </div>
    );
}
